import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LngDetector from "i18next-browser-languagedetector";
// translations. should be moved to separate files
const resources = {
  en: {
    translation: {
      feedForward: "Next steps",
      feedUp: "Learning outcomes",
      feedForward_pos: "Feed-forward (positive)",
      feedForward_neg: "Feed-forward (negative)",
      feedForward_threshold: "Feed-forward (threshold)",
      feedUp_tooltip:
        "Shown to students before they start working on the exercise, as a hint about its learning goal, regardless of their later result.",
      feedForward_pos_tooltip:
        "Shown to students whose relative score (0 to 1) reaches or exceeds the feed-forward threshold, after grading.",
      feedForward_neg_tooltip:
        "Shown to students whose relative score (0 to 1) is below the feed-forward threshold, after grading.",
      feedForward_threshold_tooltip:
        "Relative score threshold (0 to 1, e.g. 0.5 for 50%) that decides whether students see the positive or the negative feed-forward message after grading.",
      deleteFeedbackQuestion: "Do you really want to delete the following feedback message?",
      deleteFeedbackExplanation: "",
      groupBy: "Group by:",
      noGrouping: "No grouping",
      feedbackEntryCount_one: "{{count}} feedback message below",
      feedbackEntryCount_other: "{{count}} feedback messages below",
      modelLoading: "Loading the model …",
      period: "Period",
      assessmentRunning: "Grading in progress …",
      assessmentFailed: "Start failed",
      assessmentFailedHint: "The assessment could not be handed over to the grading service. Start it again for this submission.",
      assessmentUnresponsive: "No result after 3 min",
      assessmentUnresponsiveHint:
        "The assessment was started but returned no result within three minutes, so it is no longer being watched. Start it again or reload the page to check.",
      publicationPending: "Not published",
      textFileUploadAlternative: "Or replace the content with an uploaded text file:",
      statusActive: "active",
      statusScheduled: "not started yet",
      statusExpired: "expired",
      scoreTablesExplanation:
        "The upper table shows the overall result as absolute points out of the maximum score, including a manual revision if one took place. The lower table shows the contribution of each grading service: its raw result (relative results as a percentage), its weight and the partial score in points calculated from them.",
      noListFeedback:
        "There are no feedback messages in this list. Feedback that is attached to individual model elements does not appear here.",
      submissionScoreTooltip:
        "Absolute points of the most recent completed assessment out of the maximum score. A dash means that no assessment has been completed yet.",
      searchSubmissionsPlaceholder: "Search by name or matriculation number …",
      filterAllSubmissions: "All",
      filterNoAssessment: "Not assessed",
      modelLoadFailed: "The model could not be loaded. Please reload the page or try again later.",
      scoreHelperToggle: "Calculation aid for partial points",
      scoreHelperExplanation:
        "Enter a deduction per aspect; the resulting total score is calculated for you. Only the applied total score is saved, the individual deductions are not.",
      scoreHelperAspect: "Aspect (optional)",
      scoreHelperDeduction: "Deduction",
      scoreHelperAddRow: "Add deduction",
      scoreHelperResult: "Resulting score: {{score}} of {{max}} points",
      scoreHelperApply: "Apply to total score",
      scoreHelperNoMax: "This aid needs a valid maximum total score.",
      scoreHelperInvalidDeduction: "Marked deductions are not numbers and are not included in the calculation.",
      scoreHelperTakeOverFeedback: "Take over feedback",
      statisticsToggle: "Overview of all submissions",
      statisticsNoData: "No completed assessment yet, so there is nothing to summarise.",
      statisticsAssessedCount: "{{assessed}} of {{total}} submissions have a completed assessment.",
      statisticsAverage: "Average result: {{value}} of {{max}} points",
      statisticsBest: "best: {{value}}",
      statisticsWorst: "lowest: {{value}}",
      statisticsMixedMax: "The submissions of this exercise do not all share the same maximum score; the most common one is used for the ranges.",
      statisticsWithoutNegative: "{{count}} of {{total}} submissions have no negative feedback.",
      statisticsAverageNegative: "On average {{value}} negative messages per submission.",
      statisticsFeedbackSubmissions: "in {{submissions}} of {{total}} submissions",
      statisticsLoading: "still loading, the numbers are not complete yet",
      statisticsLoadingProgress: "Loading assessments: {{loaded}} of {{total}} submissions checked …",
      statisticsFilterByRule: "Show only the submissions affected by this rule",
      ruleFilterActive: "filtered by rule",
      ruleFilterClear: "remove filter",
      feedbackAnchorNotFound: "anchored model element not found — shown here instead of being marked in the model",
      listLoadFailed: "The data could not be loaded. Please reload the page or try again later.",
      listRefreshFailed: "This list could not be refreshed, so it shows the last state that loaded. Reload the page to try again.",
      bulkStartProgress: "Starting assessments: {{processed}} of {{total}} handled",
      bulkStartDone: "All {{total}} assessments were started. Grading itself runs in the background and takes longer.",
      bulkStartPartial:
        "{{started}} of {{total}} assessments were started. Those run in the background and take longer.",
      bulkStartNone: "None of the {{total}} assessments could be started. Please start them individually.",
      bulkStartFailed: "· {{failed}} could not be started, please start those individually.",
      statisticsTopFeedback: "Most frequent mistakes (grouped by rule, element names left out)",
      statisticsNoFeedback: "The grading services did not return any negative feedback.",
      statisticsFeedbackCount: "{{value}} times",
      contentTooltip: "Here you should enter the content of the feedback message.",
      categoryTooltip:
        "You have to enter a self-chosen category here (usually a single word). All feedback messages will be displayed grouped by category.",
      valuationTooltip:
        "You have to configure whether the feedback message is positive, neutral or negative. Neutral marks a remark that does not cost any points; the score itself is set separately in the assessment.",
      commentTooltip:
        "This field is optional. You can enter a comment here that will be displayed on the feedback page next to the result score.",
      absolutescoreTooltip:
        "If you want to correct the calculated total score, you can enter an absolute score here. Please note that it should be greater or equal to zero and lesser or equal to the maximum total score.",
      relativescoreTooltip:
        "If you want to correct the calculated total score, you can enter a relative score between 0 and 1 here. That means if the maximum total score is 10 points and you want to award 4 points, you have to enter 0.4. ",
      maxscoreAssTooltip:
        "The maximum total score is configured for the exercise and is only shown here. Change it in the exercise, it then applies to every submission.",
      isrevisedTooltip:
        "If the automatic assessment of the assignment after submission has been disabled, this result will only be published when you activate this option here.",
      feedbackTooltip:
        "Here all feedback to the submission is shown. You can add, edit and remove each feedback message.",
      descriptionMCTooltip:
        "Describe in detail what you expect from your students in this exercise, so they know what to do here. If possible make a reference to corresponding learning objectives.",
      descriptionCreationTooltip:
        "Describe what your students are expected to do in this exercise, if possible with a reference to the corresponding learning objectives. The situation that should be modeled does not belong here: it goes into the scenario field below.",
      languageTooltip:
        "Setting a modeling language here classifies this exercise and fixes the notation in the modeling tool: within the context of this exercise the language selector is limited to this notation and its variants, while creating an input model, sample solutions or for students entering solution models. The set of symbols offered inside that notation stays the same. ",
      scenarioTooltip:
        "The scenario is the situation to be modeled: the existing (as-is) or planned (to-be) section of the real world that students receive as the basis for their model. What they are supposed to do with it belongs into the description above.",
      schemaTooltip:
        "Assessment schemas represent the configuration of the automatic assessment for this exercise. In the current development stage you have to choose from the given list that represents a few pre-defined assessment schemas. Some of them are exercise-specific and should not be used for other exercises. If you want to create exercise-specific assessment schemas for new exercises or an individual combination and weighting of several aspects, please contact us via info@keamod.de and we will assist you further. ",
      maxscoreTooltip: "Specify the amount of maximal points a student can get for this exercise.",
      samplesolutionsTooltip:
        "Sample solutions can be handed over to specific grading services (if specified in the assessment schema) to be used for a comparison during the automatic assessment. This is currently supported by BPMN Semantic Checker and Semantic Grader only. If you want to check submissions manually, use the Dummy Grader (100%) schema.",
      inputmodelTooltip:
        "The input model is shown to students when they work on this exercise. The answer items should be related to this model.",
      questionTooltip:
        "Phrase describing the task with regard to the following answer items, e.g. ‘Are the following statements about the given model true or false’",
      answerTooltip:
        "Answer items are statements about the given model which are either true or false. Try not to include answer items which can be true or false under specific assumptions. Also if you include two answer items that are mutually exclusive, students can guess that either one of them is true and the other false.",
      descriptionTooltip:
        "Here you can add an description of the assignment. It is advisable to communicate learning objectives and context information to your students.",
      datesTooltip: "Students can only work on an assignment during the time period between start date and end date.",
      qacTooltip:
        "Distribute this quick access code to your students so they can add this assignment to their open assignments list.",
      chooseModelType: "Choose one of the following exercise types for the new exercise you want to create:",
      toolTipMC: "In model creation exercises you have to create a model for a given scenario description",
      toolTipMU: "In model understanding exercises you have to select appropriate statements about a given model",
      assessmentcardtooltip:
        "This component is grouped by the exercises. Within an exercise there are the submissions for each student",
      studentcardtooltip:
        "This component is grouped by the students. Within a student there are the submissions for each exercise",
      noAnswer: "No answer",
      creation: "Model creation",
      understanding: "Model understanding",
      totalAssignment: "Assignment total",
      BPMN: "BPMN",
      EPC: "EPC",
      ANY: "Any",
      PN: "Petri net",
      UML_CD: "UML class diagram",
      UML_CLASS: "UML class diagram",
      UML_SD: "UML state diagram",
      UML_STATE: "UML state diagram",
      UML_SEQ: "UML sequence diagram",
      UML_SEQUENCE: "UML sequence diagram",
      UML_AD: "UML activity diagram",
      UML_ACTIVITY: "UML activity diagram",
      ER: "ER diagram",
      headerTitleTeacher: "Author UI",
      headerTitleStudent: "Student UI",
      assignment: "Assignment",
      assignments: "Assignments",
      newAssignment: "Create new assignment",
      assignmentList: "Assignments",
      exercise: "Exercise",
      exercises: "Exercises",
      newExercise: "Create exercise",
      newSchema: "Create schema",
      exerciselist: "Exercises ",
      modellist: "Models ",
      schemalist: "Schemas ",
      task: "Task",
      search: "Search",
      deleteAll: "Delete all",
      title: "Title",
      description: "Description",
      status: "Status",
      edit: "Edit",
      chooseTask: "Choose task",
      chooseSchema: "Choose schema",
      chooseModel: "Choose model",
      signIn: "Sign in",
      published: "Published",
      pending: "Pending",
      unpublish: "Unpublish",
      delete: "Delete",
      update: "Update",
      updated: "Updated",
      chooseAssignment: "Please click on an assignment",
      submitSuccessfull: "Successfully submitted!",
      send: "Send",
      enterTitle: "Enter title",
      artifacts: "Artifacts",
      create: "Create",
      newSampleSolution: "Create new sample solution",
      created: "Created",
      add: "Add",
      name: "Name",
      type: "Type",
      modellinglang: "Modeling language",
      modellingTool: "Modeling tool",
      models: "Models",
      language: "Language",
      scenario: "Scenario",
      modelCreation: "Model creation",
      modelUnderstanding: "Model understanding",
      bpmn: "BPMN",
      epc: "EPC",
      petrinet: "Petri net",
      umlClass: "UML class diagram",
      umlSequence: "UML sequence diagram",
      sampleSolution: "Sample solution(s)",
      addableAfterExerciseCreated: "You can add this after creating the exercise with the button above.",
      completeBeforeSampleSolution:
        "Please fill in name, modelling language, description, scenario and assessment schema first. The exercise is saved automatically as soon as you add a sample solution.",
      exerciseSaveFailed: "The exercise could not be saved. Please try again.",
      backToAssignment: "Back to the assignment",
      noSampleSolutionAdded:
        "No sample solution has been added to this exercise yet. Without one the assessment service cannot assess the submissions properly. Do you still want to save the exercise?",
      completeBeforeAddingParts:
        "Please fill in name, modelling language, description, question and assessment schema first. The exercise is saved automatically as soon as you add a model.",
      completeBeforeSaving: "The exercise still needs the following:",
      answersSaveFailed: "The answer options could not be saved. Please try again.",
      noCorrectAnswerMarked: "None of the answer options is marked as correct. Do you still want to save the exercise?",
      noInputModelTitle: "No given model",
      noAssessmentTitle: "No completed assessment for this submission",
      noAssessmentText:
        "The last assessment did not finish, so there are no results to show yet. You can start the assessment again in the submission list, or open the manual revision to grade this submission yourself.",
      noAssessmentOnButton: "No completed assessment: The last one did not finish.",
      noInputModelDialogText:
        "No given model has been added to this exercise yet. Students would then see the question without one.",
      saveWithoutModel: "Save without a model",
      noCorrectAnswerTitle: "No correct answer option",
      noCorrectAnswerDialogText:
        "None of the answer options is marked as correct. Students can then not answer the question correctly.",
      exerciseCreatedOnSave: "The exercise is only created when you save.",
      exerciseCreatedForModel: "The exercise has already been created, because a model was added.",
      exerciseCreatedForModelNote:
        "The exercise has already been created, because a model can only be stored together with one. If you leave without saving, it stays in the assignment in this incomplete state.",
      saveWithoutCorrectAnswer: "Save anyway",
      addModelNow: "Add a model",
      backToForm: "Back to the form",
      noInputModelAdded:
        "No given model has been added to this exercise yet, so students would see the question without one. The exercise has already been created; cancelling only takes you back to the form. Continue?",
      newModel: "Create new sample solution",
      createModelButton: "Create",
      model: "Model",
      modelId: "Model ID",
      chooseFile: "Choose file",
      answer: "Answer items",
      wronganswers: "Wrong answers",
      correctanswers: "Correct answers",
      schema: "Assessment schema",
      schemas: "Assessment schemas",
      visibility: "Visibility",
      private: "private",
      internal: "internal",
      public: "public",
      question: "Question",
      signUp: "Sign up",
      content: "Content",
      logOut: "Logout",
      existing_model: "Existing model",
      assessment: "Assessment",
      Assessment: "Assessment",
      startAssessment: "Start assessment",
      showAssessment: "View results",
      currentSchema: "The currently active assessment schema is: ",
      explainButton:
        "With the buttons for 'start assessment' you can either start the automatic assessment for all submissions or for a specific submission of this exercise. The active assessment schema will be used. If you want to change the active assessment schema, go to the configuration page of the corresponding exercise. ",
      selectSubmission: "Select submission",
      refresh: "refresh",
      selectModellinglang: "Select modeling language",
      selectSchema: "Select assessment schema",
      selectSampleSolution: "Select sample solution",
      selectVisibility: "Select visibility",
      addAnswer: "Add answer item",
      answers: "Answer items",
      correct: "Correct",
      pn: "Petri net",
      uml_cd: "UML class diagram",
      uml_sd: "UML state diagram",
      uml_seq: "UML sequence diagram",
      ModelsEmpty: "No models selected",
      startDate: "Start date",
      endDate: "End date",
      endDateBeforeStartDate: "The end date must be after the start date.",
      endDateInPast: "The end date is in the past, so the assignment would already be expired for students. Create it anyway?",
      addModel: "Add model",
      editModel: "Edit model",
      deleteModel: "Delete model",
      createExercise: "Create new exercise",
      lateExerciseHint:
        "Exercises added later are not available to students who have already worked on this assignment. This is intended: it keeps assignments consistent once they are in use.",
      createFeedback: "Create new feedback",
      feedbackAnchor: "Anchor in the model",
      feedbackAnchorHint: "Click an element in the model to anchor this entry to it.",
      feedbackAnchorHintDialog:
        "No element selected. Close this dialog, click an element in the model, then create the message again.",
      gradingBreakdown: "Where the automatic score comes from",
      gradingBreakdownResult: "Result",
      gradingBreakdownWeight: "Weight",
      gradingBreakdownPoints: "Points",
      gradingBreakdownHintWeights: "The weights of these services do not add up to 100 %, but to",
      gradingBreakdownHint:
        "Each service returns a relative result. Its points are that result times its weight times the maximum score.",
      gradingBreakdownHintAbsolute:
        "At least one service returns absolute points, so the results are shown as reported.",
      numberAssessed: "Assessed",
      averageShare: "Average",
      feedbackAnchorUnnamed: "Selected element (no name)",
      feedbackAnchorClear: "Remove anchor",
      elementTypeActivity: "Activity",
      elementTypeGateway: "Gateway",
      elementTypeSwimlane: "Swimlane",
      elementTypeLink: "Edge",
      elementTypeEvent: "Event",
      elementTypeEventStart: "Start event",
      elementTypeEventIntermediate: "Intermediate event",
      elementTypeEventEnd: "End event",
      showInModel: "Show in the model",
      numberAtElement: "This number is drawn at the model element",
      numberWithoutElement: "Not anchored, so this number does not appear in the model",
      quickAccessCode: "Quick Access Code",
      options: "Options",
      noExercises: "There are no exercises yet!",
      saveAssignment: "Save Assignment",
      saveExercise: "Save Exercise",
      noSubmissions: "There are no submissions yet!",
      noFeedbacks: "There are no feedbacks yet!",
      back: "Back",
      noAssessment: "There is no assessment yet!",
      noAssignment: "There are no assignments yet!",
      submissions: "Submissions",
      cancel: "Cancel",
      allSubmissionsForExercise: "Here you can see all submissions for this exercise.",
      allSubmissionsForStudent: "Here you can see all submissions for the chosen student.",
      allExercisesInAssignment: "Here you can find all exercises of this assignment. ",
      allAssignments:
        "Here you can create new assignments and edit them. An assignment bundles several individual exercises on a topic (like a worksheet) under a shared time period and access code. Students work on and submit them together. It is also possible to click on 'Assessment' to see all exercises included in the assignment and the corresponding submissions.",
      comment: "Comment",
      totalScore: "Total score",
      maxTotalScore: "Maximum total score",
      noModel: "There is no sample solution yet!",
      autoAssessmentAss: "Automatic assessment on submission",
      autoAssessmentEx: "Automatic assessment on saving solution",
      save: "Save",
      noComment: "No comment",
      ManualAssessment: "Manual revision",
      ManualAssessmentAction: "Correct submission",
      category: "Category",
      valuation: "Valuation",
      valuationNegative: "Negative",
      valuationPositive: "Positive",
      valuationNeutral: "Neutral",
      valuationNeutralHint: "remark without deduction",
      valuationOther: "Other",
      autoAssessmentExDesc:
        "Setting this option to yes, solutions for this exercise will be assessed automatically (i.e. feedback is generated) each time the student saves his/her solution. This allows students to work towards a good-solution step-by-step (multiple-try feedback). If the option is off, the solution is only assessed once it is submitted.",
      autoAssessmentAssDesc:
        "When on, all submitted solutions in this assignment are graded automatically and the feedback is published to students right away. Recommendation: leave it off if you want to review the results first. You then grade manually under 'Assessment' and revise before publishing.",
      noAnswers: "There are no answer items yet!",
      answerCorrectColumn: "Correct?",
      answerIsCorrect: "Correct answer",
      answerIsWrong: "Wrong answer",
      markAsCorrect: "Mark this option as a correct answer",
      solution: "Solution",
      noSolution: "There is no solution yet!",
      exerciseModelCreation: "Exercise Model Creation",
      exerciseModelUnderstanding: "Exercise Model Understanding",
      true: "True",
      false: "False",
      integratedFeedback: "Integrated Feedback",
      ShowModel: "Show Model",
      preview: "Preview",
      MaxScore: "Maximum totalscore",
      maxScoreInvalidInput: "Only numbers are allowed here.",
      relativeScoreRange: "Please enter a value between 0 and 1 (for example 0.4 for 40%).",
      absoluteScoreRange: "Please enter a value between 0 and {{max}} points.",
      totalScoreNoMax: "Please set a maximum total score first, so the awarded points can be saved.",
      ofMaxPoints: "of {{max}} points",
      SwitchRoleStudent: "Go to student view",
      newInputModel: "Create input model",
      inputModel: "Input model",
      proceed: "Yes, proceed",
      deleteConfirmationAssignment: "Do you really want to delete the following assignment?",
      deleteConfirmationAssignmentIrreversible:
        "This process is irreversible. All corresponding exercises, submissions and assessments will be lost.",
      confirmationRequest: "Confirmation Request",
      deleteConfirmationExercise: "Do you really want to delete the following exercise?",
      deleteConfirmationExerciseIrreversible:
        "This process is irreversible. All corresponding submissions and assessments will be lost.",
      FeedbackForExercise: "Feedback for exercise",
      gradingServices: "Grading Services",
      gradingService: "Grading Service",
      PositionX: "Position X",
      PositionY: "Position Y",
      requested: "Started",
      finished: "Finished",
      percentage: "Percentage",
      Score: "Score",
      weight: "Weight",
      result: "Result",
      partialScore: "Partial score",
      resulttype: "Result type",
      RELATIVE: "relative",
      ABSOLUTE: "absolute",
      editFeedback: "Edit Feedback",
      noeditwarning1: "If you want to revise multiple choice answers, please go to the ",
      noeditwarning2: "exercise configuration",
      noeditwarning3: "and rerun the assessment afterwards.",

      assessAllSubmissions: "Start assessment for all submissions",

      loggedInAs: "Logged in as",
      Revised: "Published",
      reviewedHeader: "Correction status",
      reviewedDone: "done",
      reviewedOpen: "open",
      reviewedTooltip:
        "Mark a submission as corrected to keep track of your progress. Saving an assessment does not set the mark on its own, you decide that in the manual revision or here. The mark is stored with the submission, so other correctors see it as well.",
      markAsReviewed: "Correction finished",
      markAsReviewedTooltip:
        "Only tick this when you are done with this submission. It marks the submission as corrected in the overview and is not set by saving alone. To take the mark back, use the submission list.",
      markAsReviewedAlready: "This submission is already marked as corrected. You can take that back in the submission list.",
      reviewFlagFailed: "The correction mark could not be saved. Please try again.",
      publishReviewed: "Publish corrected results",
      publishOne: "Publish",
      publishOneExplanation: "Publishes the result of this single submission.",
      publishOneBlocked: "Mark this submission as corrected first, then its result can be published.",
      withdrawOne: "Withdraw",
      withdrawPublished: "Withdraw published results",
      withdrawPublishedSelection_one: "{{count}} published submission",
      withdrawPublishedSelection_other: "{{count}} published submissions",
      withdrawPublishedQuestion: "Do you really want to withdraw the results of the following submissions?",
      withdrawPublishedExplanation:
        "The scores stay as they are, students just cannot see them any more until they are published again.",
      withdrawPublishedDone: "{{number}} results withdrawn.",
      withdrawPublishedPartly: "{{number}} results withdrawn, {{failed}} failed.",
      publishReviewedRunning: "Publishing results...",
      publishReviewedSelection: "{{number}} corrected submission(s) that are not published yet",
      publishReviewedQuestion: "Do you really want to publish the results of the following submissions?",
      publishReviewedExplanation:
        "The students can see their results right afterwards. Submissions that are not marked as corrected stay unpublished.",
      publishReviewedTooltip:
        "Publishes the results of all submissions that are marked as corrected and not published yet. Submissions still marked as open are left out.",
      publishReviewedDone: "{{number}} result(s) published.",
      publishReviewedPartly: "{{number}} result(s) published, {{failed}} failed. Please try again for the rest.",
      numberOfSubmissions: "Number of submissions",
      numberOfPublished: "Number of published submissions",
      isRevised: "Publish results",
      avgScores: "(average total score)",
      user: "User",
      startAssessmentQuestion:
        "Do you really want to trigger an assessment for all submissions of the following exercise?",
      startAssessmentSingleQuestion:
        "Do you really want to trigger an assessment for the following person's submission?",
      startAssessmentSingleQuestionExercise:
        "Do you really want to trigger an assessment for the submission of the following exercise?",
      startAssessmentExplanation:
        "If you continue, the previous result will be overwritten. Any corrections you have already made will also be lost. If you don't want this to happen, you can also trigger an assessment specifically for individual submissions.",
      startAssessmentSingleExplanation:
        "If you continue, the previous result will be overwritten. Any corrections you have already made will also be lost. ",
      CheckfornewFeedback:
        "If you have started the automatic assessment, it takes a while until all assessments have been performed. Use the reload button to the right to refresh the results from time to time until all assessments are finished.",
      students: "Students",
      studentSubmissionsForAssignment:
        "Here you can find all students that already submitted exercises of the assignment.",
      exerciseType: "Exercise type",
      actions: "Actions",
      treeViewEditSchema: "Edit schema",
      treeViewAddSchema: "Add child schema",
      treeViewAddGradingService: "Add grading service",
      treeViewEditGradingServiceParameter: "Edit parameters",
      schemaTreeTooltipWeight100: "The weight of the children sums up to 100%.",
      schemaTreeTooltipWeightNot100: "The weight of the children does not sum up to 100%.",
      schemaTreeTooltipNoChildren: "This schema has no children.",
      newKeyValueDefaultKey: "Key",
      newKeyValueDefaultValue: "Value",
      newKeyValueDefaultDescription: "Description",
      "key-value-pairs": "Key value pairs",
      addKeyValueItem: "Add key value pair",
      textFiles: "Text files",
      newTextFileDefaultName: "newtextfile",
      newTextFileDefaultContent: "Content",
      addTextFile: "Add text file",
      addchildgradingservice: "Add child grading service",
      gradingservice: "Grading service",
      selectGradingService: "Select grading service",
      searchGradingService: "Search grading services …",
      noGradingServiceMatch: "No grading service matches the search.",
      modelingLanguage: "Modeling language",
      interactionLog: "Interaction log",
      scenarioGSTooltip: "If enabled, this grading service receives the scenario text of the exercise as an input.",
      modelingLanguageGSTooltip: "If enabled, this grading service receives the modeling language of the exercise as an input.",
      interactionLogGSTooltip: "If enabled, this grading service receives the interaction log of the submission (editing steps recorded in the modeling editor) as an input.",
      weightTooltip:
        "The weight of the schema in relation to its siblings, in percent. Must be a value between 0 and 100.",
      weightTooltipGradingService:
        "The weight of this grading service in relation to its siblings, in percent. Must be a value between 0 and 100.",
      treeViewNoDescription: "No description available.",
      noSchema: "No schemas available!",
      alreadyCreatingGradingServiceEdge: "The child grading service is already being created.",
      fillAllFields: "Please make sure that all fields have been filled out",
      weightBetween0And100: "Please make sure that the weight is between 0 and 100.",
      alreadyCreatingSchema: "The schema is already being created.",
      addChildSchema: "Add child assessment schema",
      createRootSchema: "Create new root assessment schema",
      rootSchemaTooltip:
        "A root schema is the top level of an assessment schema. Under it you combine sub-schemas and grading services, each with a weight, to define how an exercise is graded automatically.",
      childSchemaTooltip:
        "A sub-schema groups further grading services or sub-schemas under a parent schema. Its weight sets how much this group contributes to the parent's result.",
      gradingServiceRoleTooltip:
        "A grading service is the component that actually checks one aspect of a submission (for example syntax or semantics). You attach it under a schema with a weight that sets its share of the result.",
      keyValueEmptyError: "Key and value must not be empty",
      updateInProgress: "The grading service parameters are already updating.",
      errorCreatingSchema: "An error occurred while creating the schema.",
      treeViewDeleteConfirmationSchemaAndChildren:
        "Do you really want to delete the schema and all its children (grading services and schemas)?",
      irreversibleStep: "This step is irreversible.",
      deleteConfirmationGradingService: "Do you really want to remove this grading service from this schema?",
      deleteConfirmationGradingServiceIrreversible: "This step is irreversible.",
      errorOccurred: "An error occurred.",
      parameterOfGradingservice: "Parameters of grading service {gs} (#{id})",
      key: "Key",
      value: "Value",
      filename: "Filename",
      downloadTextFile: "Download text file",
      onlyChangeOnUpdatePress: "Changes will only be saved when you press the 'Update' button.",
      Schema: "Schema",
      SchemaRoot: "Root schema",
      GradingService: "Grading service",
      treeViewEditGradingServiceWeight: "Edit weight",
      schemaispublic: "Public sharing of schema (read-only)",
      PrivateSchema: "This schema is owned by another user and is not public.",
      schematreeviewreadonly: "You do not have permission to edit this item.",
      navschematreeview: "Schemas",
    },
  },
  de: {
    translation: {
      feedForward: "Nächste Schritte",
      feedUp: "Lernziele (Feed-Up)",
      feedForward_pos: "Feed-Forward (positiv)",
      feedForward_neg: "Feed-Forward (negativ)",
      feedForward_threshold: "Feed-Forward Schwellwert",
      feedUp_tooltip:
        "Wird Studierenden vor der Bearbeitung als Hinweis zum Lernziel dieser Aufgabe angezeigt, unabhängig vom späteren Ergebnis.",
      feedForward_pos_tooltip:
        "Wird nach der Bewertung Studierenden angezeigt, deren relative Punktzahl (0 bis 1) den Feed-Forward-Schwellwert erreicht oder überschreitet.",
      feedForward_neg_tooltip:
        "Wird nach der Bewertung Studierenden angezeigt, deren relative Punktzahl (0 bis 1) unter dem Feed-Forward-Schwellwert liegt.",
      feedForward_threshold_tooltip:
        "Relative Punktzahl-Schwelle (0 bis 1, z. B. 0,5 für 50 %), ab der Studierenden nach der Bewertung das positive statt das negative Feed-Forward angezeigt wird.",
      CheckfornewFeedback:
        "Wenn Sie die automatisierte Bewertung angestoßen haben, dauert es eine Weile bis alle Ergebnisse berechnet wurden. Verwenden Sie den 'Neu Laden'-Button rechts, um diese Seite gelegentlich neuzuladen, bis alle Ergebnisse eingetragen wurden.",
      deleteFeedbackQuestion: "Möchten Sie die folgende Feedback-Nachricht wirklich löschen?",
      deleteFeedbackExplanation: "",
      startAssessmentQuestion:
        "Möchten Sie wirklich die Bewertung für alle Einreichungen zur folgenden Aufgabe anstoßen?",
      startAssessmentSingleQuestion:
        "Möchten Sie wirklich eine Bewertung für die Einreichung der folgenden Person anstoßen?",
      startAssessmentSingleQuestionExercise:
        "Möchten Sie wirklich eine Bewertung für die Einreichung der folgenden Aufgabe anstoßen?",
      startAssessmentExplanation:
        "Wenn Sie fortfahren, werden alle vorherigen Ergebnisse überschrieben. Auch eventuelle Korrekturen, die Sie bereits vorgenommen haben, gehen dabei verloren. Wenn Sie dies nicht möchten, können Sie auch gezielt für einzelne Einreichungen die automatisierte Bewertung anstoßen.",
      startAssessmentSingleExplanation:
        "Wenn Sie fortfahren, wird das vorherige Ergebnis überschrieben. Auch eventuelle Korrekturen, die Sie bereits vorgenommen haben, gehen dabei verloren. ",
      user: "Erstellt von",
      avgScores: "(Durchschnittliche Gesamtpunktzahl)",
      explainButton:
        "Mit den Buttons 'Bewertung starten' können Sie die automatisierte Bewertung für alle oder für eine bestimmte Einreichung anstoßen. Dabei wird das aktive Bewertungsschema verwendet. Wenn Sie dieses ändern möchten, gehen Sie zur Konfigurationsseite der betreffenden Aufgabe.",
      groupBy: "Gruppieren nach:",
      noGrouping: "Ohne Gruppierung",
      feedbackEntryCount_one: "{{count}} Feedback-Nachricht weiter unten",
      feedbackEntryCount_other: "{{count}} Feedback-Nachrichten weiter unten",
      modelLoading: "Modell wird geladen …",
      period: "Zeitraum",
      assessmentRunning: "Bewertung läuft …",
      assessmentFailed: "Anstoß fehlgeschlagen",
      assessmentFailedHint: "Die Bewertung konnte nicht an den Bewertungsdienst übergeben werden. Starten Sie sie für diese Einreichung erneut.",
      assessmentUnresponsive: "Kein Ergebnis nach 3 Min.",
      assessmentUnresponsiveHint:
        "Die Bewertung wurde angestoßen, hat aber innerhalb von drei Minuten kein Ergebnis geliefert und wird nicht mehr überwacht. Starten Sie sie erneut oder laden Sie die Seite neu, um nachzusehen.",
      publicationPending: "Nicht veröffentlicht",
      textFileUploadAlternative: "Oder den Inhalt durch eine hochgeladene Textdatei ersetzen:",
      statusActive: "aktiv",
      statusScheduled: "noch nicht gestartet",
      statusExpired: "abgelaufen",
      scoreTablesExplanation:
        "Die obere Tabelle zeigt das Gesamtergebnis als absolute Punkte von der Maximalpunktzahl, inklusive einer eventuellen manuellen Revision. Die untere Tabelle zeigt den Beitrag der einzelnen Bewertungsdienste: Rohergebnis (relative Ergebnisse in Prozent), Gewichtung und die daraus berechneten Teilpunkte.",
      noListFeedback:
        "In dieser Liste liegen keine Feedback-Nachrichten vor. Feedback, das an einzelnen Modellelementen verankert ist, erscheint hier nicht.",
      submissionScoreTooltip:
        "Absolute Punkte der letzten abgeschlossenen Bewertung von der Maximalpunktzahl. Ein Strich bedeutet, dass noch keine Bewertung abgeschlossen wurde.",
      searchSubmissionsPlaceholder: "Nach Name oder Matrikelnummer suchen …",
      filterAllSubmissions: "Alle",
      filterNoAssessment: "Ohne Bewertung",
      modelLoadFailed: "Das Modell konnte nicht geladen werden. Bitte die Seite neu laden oder später erneut versuchen.",
      scoreHelperToggle: "Rechenhilfe für Teilpunkte",
      scoreHelperExplanation:
        "Tragen Sie je Aspekt einen Punktabzug ein; die resultierende Gesamtpunktzahl wird automatisch berechnet. Gespeichert wird nur die übernommene Gesamtpunktzahl, nicht die einzelnen Abzüge.",
      scoreHelperAspect: "Aspekt (optional)",
      scoreHelperDeduction: "Abzug",
      scoreHelperAddRow: "Abzug hinzufügen",
      scoreHelperResult: "Ergebnis: {{score}} von {{max}} Punkten",
      scoreHelperApply: "In Gesamtpunktzahl übernehmen",
      scoreHelperNoMax: "Die Rechenhilfe benötigt eine gültige maximale Gesamtpunktzahl.",
      scoreHelperInvalidDeduction: "Markierte Abzüge sind keine Zahlen und fließen nicht in die Berechnung ein.",
      scoreHelperTakeOverFeedback: "Feedback übernehmen",
      statisticsToggle: "Überblick über alle Einreichungen",
      statisticsNoData: "Noch keine abgeschlossene Bewertung vorhanden, daher gibt es nichts zusammenzufassen.",
      statisticsAssessedCount: "{{assessed}} von {{total}} Einreichungen haben eine abgeschlossene Bewertung.",
      statisticsAverage: "Durchschnittliches Ergebnis: {{value}} von {{max}} Punkten",
      statisticsBest: "bestes: {{value}}",
      statisticsWorst: "niedrigstes: {{value}}",
      statisticsMixedMax: "Nicht alle Einreichungen dieser Aufgabe haben dieselbe Maximalpunktzahl; für die Bereiche wird die häufigste verwendet.",
      statisticsWithoutNegative: "{{count}} von {{total}} Einreichungen haben kein negatives Feedback.",
      statisticsAverageNegative: "Im Schnitt {{value}} negative Meldungen je Einreichung.",
      statisticsFeedbackSubmissions: "in {{submissions}} von {{total}} Einreichungen",
      statisticsLoading: "wird noch geladen, die Zahlen sind unvollständig",
      statisticsLoadingProgress: "Bewertungen werden geladen: {{loaded}} von {{total}} Einreichungen geprüft …",
      statisticsFilterByRule: "Nur die von dieser Regel betroffenen Einreichungen anzeigen",
      ruleFilterActive: "gefiltert nach Regel",
      ruleFilterClear: "Filter aufheben",
      feedbackAnchorNotFound: "verankertes Modellelement nicht auffindbar — wird hier gezeigt statt im Modell markiert",
      listLoadFailed: "Die Daten konnten nicht geladen werden. Bitte laden Sie die Seite neu oder versuchen Sie es später erneut.",
      listRefreshFailed: "Diese Liste konnte nicht aktualisiert werden und zeigt den zuletzt geladenen Stand. Laden Sie die Seite neu, um es erneut zu versuchen.",
      bulkStartProgress: "Bewertungen werden angestoßen: {{processed}} von {{total}} bearbeitet",
      bulkStartDone: "Alle {{total}} Bewertungen wurden angestoßen. Die Bewertung selbst läuft im Hintergrund und dauert länger.",
      bulkStartPartial:
        "{{started}} von {{total}} Bewertungen wurden angestoßen. Diese laufen im Hintergrund weiter und dauern länger.",
      bulkStartNone: "Keine der {{total}} Bewertungen konnte angestoßen werden. Bitte einzeln nachstarten.",
      bulkStartFailed: "· {{failed}} ließen sich nicht anstoßen, bitte einzeln nachstarten.",
      statisticsTopFeedback: "Häufigste Fehler (nach Regel gruppiert, ohne Elementnamen)",
      statisticsNoFeedback: "Die Bewertungsdienste haben kein negatives Feedback zurückgegeben.",
      statisticsFeedbackCount: "{{value}} mal",
      contentTooltip: "Hier sollten Sie den Inhalt der Feedback-Nachricht festlegen.",
      categoryTooltip:
        "Sie müssen hier eine selbstgewählte Kategorie eingeben (typischerweise ein einzelnes Wort, z.B. 'Syntax'). Alle Feedback-Nachrichten werden nach Kategorie gruppiert angezeigt.",
      valuationTooltip:
        "Hier müssen Sie einstellen, ob die Feedback-Nachricht eine positive, negative oder neutrale Beurteilung enthält. Neutral kennzeichnet eine Anmerkung ohne Punktabzug; die Punkte selbst legen Sie getrennt über die Bewertung fest.",
      commentTooltip:
        "Dieses Feld ist optional. Sie können hier einen Kommentar einfügen, der auf der Feedback-Seite neben dem Bewertungsergebnis angezeigt wird.",
      absolutescoreTooltip:
        "Wenn Sie die berechnete Gesamtpunktzahl korrigieren möchten, können Sie hier einen absoluten Wert eingeben. Bitte beachten Sie dabei, dass dieser Wert größer gleich 0 und kleiner gleich der maximalen Gesamtpunktzahl sein sollte.",
      relativescoreTooltip:
        "Wenn Sie die berechnete Gesamtpunktzahl korrigieren möchten, können Sie hier einen relativen Wert zwischen 0 und 1 eingeben. Wenn beispielsweise die maximale Gesamtpunktzahl 10 Punkte beträgt und Sie 4 Punkte vergeben möchten, geben Sie hier 0.4 ein.",
      maxscoreAssTooltip:
        "Die maximale Gesamtpunktzahl wird an der Aufgabe festgelegt und hier nur angezeigt. Ändern Sie sie in der Aufgabe, dann gilt sie für alle Einreichungen.",
      isrevisedTooltip:
        "Wenn die automatisierte Bewertung der Aufgabenreihe bei Einreichung deaktiviert wurde, wird dieses Ergebnis erst veröffentlicht, wenn Sie diese Option hier aktivieren.",
      feedbackTooltip:
        "Hier werden alle Feedback-Nachrichten zu dieser Einreichung angezeigt. Sie können neue Feedback-Nachrichten hinzufügen und bestehende bearbeiten oder löschen.",
      isRevised: "Ergebnisse veröffentlichen",
      descriptionMCTooltip:
        "Beschreiben Sie im Detail, was von Studierenden bei der Bearbeitung dieser Aufgabe erwartet wird. Gegebenenfalls können hier auch Hinweise auf bestimmte Lernziele wiederholt werden. ",
      descriptionCreationTooltip:
        "Beschreiben Sie, was Studierende bei der Bearbeitung dieser Aufgabe tun sollen, gegebenenfalls mit Hinweis auf Lernziele. Der zu modellierende Sachverhalt selbst gehört nicht hierher, sondern in das Szenario-Feld darunter.",
      languageTooltip:
        "Das Festlegen einer Modellierungssprache dient der Klassifikation der Aufgabe und legt die Notation im Modellierungseditor fest: Die Sprachauswahl ist dort auf diese Notation und ihre Varianten beschränkt, und zwar im gesamten Kontext dieser Aufgabe für die Erstellung eines gegebenen Modells, Musterlösungen und für Studierende, die eine Lösung für eine 'Modell verstehen'-Aufgabe eingeben. Die Auswahl an Symbolen innerhalb der Notation bleibt davon unberührt. ",
      scenarioTooltip:
        "Das Szenario ist der zu modellierende Sachverhalt, also der existierende (as-is) oder geplante (to-be) Realitätsausschnitt, den Studierende als Grundlage für ihr Modell erhalten. Was sie damit tun sollen, steht in der Beschreibung darüber.",
      schemaTooltip:
        "Bewertungsschemata legen die Konfiguration der automatisierten Bewertung dieser Aufgabe fest. Im aktuellen Entwicklungsstadium können Sie aus einer Liste vorgegebener Bewertungsschemata auswählen. Einige davon sind aufgabenspezifisch und sollten nicht für andere Aufgaben verwendet werden. Wenn Sie aufagbenspezifische Bewertungsschemata für neue eigene Aufgaben erstellen möchten oder eine individuelle Kombination und Gewichtung verschiedener Aspekte vornehmen möchten, kontaktieren Sie uns unter info@keamod.de, damit wir Sie dabei unterstützen können. ",
      maxscoreTooltip:
        "Geben Sie die maximale Punktzahl an, die Studierende bei der Bearbeitung dieser Aufgabe erreichen können",
      samplesolutionsTooltip:
        "Musterlösungen können bestimmten Bewertungsdiensten übergeben werden (wenn dies im Bewertungsschema spezifiziert wurde) um einen Vergleich während der automatisierten Bewertung zu erreichen. Dies wird momentan nur durch den BPMN Semantic Checker und den Semantic Grader unterstützt. Wenn Sie die Einreichungen manuell bewerten möchten, wählen Sie hier den Dummy Grader (100%) als Bewertungsschema aus.",
      inputmodelTooltip: "Das gegebene Modell wird Studierenden angezeigt, wenn sie diese Aufgabe bearbeiten.",
      questionTooltip:
        "Legen Sie eine konkrete Frage oder Aufgabenstellung in Bezug auf die vorgegebenen Antwortoptionen fest, z.B. ‘Sind die folgenden Aussagen zum gegebenen Modell richtig oder falsch?’",
      answerTooltip:
        "Antwortoptionen sind Aussagen zum gegebenen Modell, die entweder wahr oder falsch sind. Versuchen Sie, keine Antwortoptionen festzulegen, die unter gegebenen Umständen sowohl wahr als auch falsch sein können. Ebenso sollten Sie keine zwei Antwortoptionen festlegen, die sich gegenseitig ausschließen, da Studierende daraus bereits schließen können, dass jeweils eine dieser Antwortoptionen wahr und die andere falsch ist. ",
      descriptionTooltip:
        "Legen Sie eine Beschreibung für die Aufgabenreihe fest. Es empfiehlt sich, Lernziele und Kontextinformationen gegenüber Studierenden transparent zu kommunizieren.",
      datesTooltip:
        "Studierende können eine Aufgabenreihe nur in der festgelegten Zeitspanne zwischen Start- und Enddatum bearbeiten. ",
      qacTooltip:
        "Verteilen Sie diesen Zugriffscode an Ihre Studierenden, damit diese die Aufgabenreihe abonnieren können. ",
      assessAllSubmissions: "Bewertung für alle Einreichungen starten",
      assessmentcardtooltip:
        "In dieser Komponente wurde nach Aufgaben gruppiert. Innerhalb der Aufgaben befinden sich die jeweiligen Einreichungen der Studenten",
      studentcardtooltip:
        "In dieser Komponente wurde nach Studenten gruppiert. Innerhalb eines Studenten befinden sich die jeweiligen Einreichungen zu den Aufgaben",
      Revised: "Veröffentlicht",
      loggedInAs: "Eingeloggt als",
      reviewedHeader: "Korrekturstatus",
      reviewedDone: "erledigt",
      reviewedOpen: "offen",
      reviewedTooltip:
        "Markiert eine Einreichung als korrigiert, damit Sie den Überblick behalten. Das Speichern einer Bewertung setzt die Markierung nicht von allein, das entscheiden Sie in der manuellen Revision oder hier. Die Markierung wird an der Einreichung gespeichert, andere Korrigierende sehen sie also auch.",
      markAsReviewed: "Korrektur abgeschlossen",
      markAsReviewedTooltip:
        "Setzen Sie das Häkchen nur, wenn Sie mit dieser Einreichung fertig sind. Sie wird dann in der Übersicht als korrigiert geführt. Das Speichern allein setzt die Markierung nicht. Zurücknehmen können Sie sie in der Einreichungsliste.",
      markAsReviewedAlready:
        "Diese Einreichung ist bereits als korrigiert markiert. Zurücknehmen können Sie das in der Einreichungsliste.",
      reviewFlagFailed: "Die Korrektur-Markierung konnte nicht gespeichert werden. Bitte versuchen Sie es erneut.",
      publishReviewed: "Korrigierte Ergebnisse veröffentlichen",
      publishOne: "Veröffentlichen",
      publishOneExplanation: "Veröffentlicht das Ergebnis dieser einen Einreichung.",
      publishOneBlocked: "Markieren Sie die Einreichung zuerst als korrigiert, dann kann ihr Ergebnis veröffentlicht werden.",
      withdrawOne: "Zurücknehmen",
      withdrawPublished: "Veröffentlichung zurücknehmen",
      withdrawPublishedSelection_one: "{{count}} veröffentlichte Einreichung",
      withdrawPublishedSelection_other: "{{count}} veröffentlichte Einreichungen",
      withdrawPublishedQuestion:
        "Möchten Sie die Veröffentlichung der folgenden Einreichungen wirklich zurücknehmen?",
      withdrawPublishedExplanation:
        "Die Punkte bleiben unverändert, Studierende sehen sie nur nicht mehr, bis erneut veröffentlicht wird.",
      withdrawPublishedDone: "{{number}} Veröffentlichungen zurückgenommen.",
      withdrawPublishedPartly: "{{number}} zurückgenommen, {{failed}} fehlgeschlagen.",
      publishReviewedRunning: "Ergebnisse werden veröffentlicht...",
      publishReviewedSelection: "{{number}} korrigierte, noch nicht veröffentlichte Einreichung(en)",
      publishReviewedQuestion: "Möchten Sie die Ergebnisse der folgenden Einreichungen wirklich veröffentlichen?",
      publishReviewedExplanation:
        "Die Studierenden sehen ihr Ergebnis direkt danach. Einreichungen ohne Korrektur-Markierung bleiben unveröffentlicht.",
      publishReviewedTooltip:
        "Veröffentlicht die Ergebnisse aller Einreichungen, die als korrigiert markiert und noch nicht veröffentlicht sind. Einreichungen mit Status offen bleiben außen vor.",
      publishReviewedDone: "{{number}} Ergebnis(se) veröffentlicht.",
      publishReviewedPartly:
        "{{number}} Ergebnis(se) veröffentlicht, {{failed}} fehlgeschlagen. Bitte für den Rest erneut versuchen.",

      noAnswer: "Keine Antwort",
      noeditwarning1: "Falls Sie Multiple Choice Antworten bearbeiten möchten, verwenden Sie bitte die ",
      noeditwarning2: "Bearbeitungsseite der Aufgabe",
      noeditwarning3: "und stoßen Sie bitte eine neue Bewertung an.",
      currentSchema: "Das derzeit aktive Bewertungsschema ist: ",
      creation: "Modell erstellen",
      percentage: "Anteil",
      Score: "Gesamtpunkte",
      requested: "Angelegt",
      RELATIVE: "relativ",
      ABSOLUTE: "absolut",
      editFeedback: "Feedback anpassen",
      weight: "Gewichtung",
      result: "Ergebnis",
      resulttype: "Ergebnistyp",
      partialScore: "Teilpunkte",
      finished: "Fertiggestellt",
      understanding: "Modell verstehen",
      totalAssignment: "Aufgabenreihe gesamt",
      ANY: "Beliebig",
      BPMN: "BPMN",
      EPC: "EPK",
      PN: "Petri Netz",
      UML_CD: "UML Klassendiagramm",
      UML_CLASS: "UML Klassendiagramm",
      UML_SD: "UML Zustandsdiagramm",
      UML_STATE: "UML Zustandsdiagramm",
      UML_SEQ: "UML Sequenzdiagramm",
      UML_SEQUENCE: "UML Sequenzdiagramm",
      UML_AD: "UML Aktivitätsdiagramm",
      UML_ACTIVITY: "UML Aktivitätsdiagramm",
      ER: "ER-Diagramm",
      gradingService: "Bewertungsdienst",
      gradingServices: "Bewertungsdienste",
      PositionX: "Position X",
      PositionY: "Position Y",
      inputModel: "Gegebenes Modell",
      Assessment: "Bewertung",
      FeedbackForExercise: "Feedback zur Aufgabe",
      newInputModel: "Gegebenes Modell erstellen",
      newSampleSolution: "Musterlösung erstellen",
      headerTitleTeacher: "Author UI",
      headerTitleStudent: "Student UI",
      assignment: "Aufgabenreihe",
      assignments: "Aufgabenreihen",
      newAssignment: "Aufgabenreihe erstellen",
      back: "Zurück",
      ManualAssessment: "Manuelle Revision",
      ManualAssessmentAction: "Korrigieren",
      assignmentList: "Aufgabenreihen",
      exercise: "Aufgabe",
      exercises: "Aufgaben",
      newExercise: "Aufgabe erstellen",
      newSchema: "Schema erstellen",
      schemalist: "Schemata",
      modellist: "Modelle",
      valuation: "Beurteilung",
      valuationNegative: "Negativ",
      valuationPositive: "Positiv",
      valuationNeutral: "Neutral",
      valuationNeutralHint: "Anmerkung ohne Punktabzug",
      valuationOther: "Sonstige",
      save: "Speichern",
      noComment: "Kein Kommentar",
      exerciselist: "Aufgaben",
      search: "Suchen",
      deleteAll: "Alle löschen",
      title: "Titel",
      description: "Beschreibung",
      status: "Status",
      edit: "Bearbeiten",
      chooseTask: "Aufgabe auswählen",
      chooseModel: "Modell auswählen",
      chooseSchema: "Schema auswählen",
      signIn: "Anmelden",
      published: "Veröffentlicht",
      pending: "In Bearbeitung",
      unpublish: "Veröffentlichung zurückziehen",
      delete: "Löschen",
      update: "Aktualisieren",
      updated: "Aktualisiert",
      chooseAssignment: "Bitte eine Aufgabe auswählen",
      submitSuccessfull: "Erfolgreich erstellt!",
      send: "Senden",
      enterTitle: "Titel eingeben",
      artifacts: "Artefakte",
      create: "Erstellen",
      created: "Erstellungsdatum",
      add: "Hinzufügen",
      name: "Name",
      type: "Typ",
      modellinglang: "Modellierungssprache",
      modellingTool: "Modellierungseditor",
      language: "Sprache",
      scenario: "Szenario",
      modelCreation: "Modell erstellen",
      modelUnderstanding: "Modell verstehen",
      chooseModelType: "Wählen Sie für die neu zu erstellende Aufgabe einen der folgenden Aufgabentypen aus:",
      any: "Beliebig",
      bpmn: "BPMN",
      epc: "EPK",
      petrinet: "Petri Netz",
      umlClass: "UML Klassendiagramm",
      umlSequence: "UML Sequenzdiagramm",
      sampleSolution: "Musterlösung(en)",
      addableAfterExerciseCreated: "Sie können dies hinzufügen, nachdem Sie die Aufgabe mit dem Button oben angelegt haben.",
      completeBeforeSampleSolution:
        "Bitte füllen Sie zuerst Name, Modellierungssprache, Beschreibung, Szenario und Bewertungsschema aus. Die Aufgabe wird automatisch gespeichert, sobald Sie eine Musterlösung hinzufügen.",
      exerciseSaveFailed: "Die Aufgabe konnte nicht gespeichert werden. Bitte versuchen Sie es erneut.",
      backToAssignment: "Zurück zur Aufgabenreihe",
      noSampleSolutionAdded:
        "Für diese Aufgabe ist noch keine Musterlösung hinterlegt. Ohne Musterlösung kann der Bewertungsdienst die Einreichungen nicht sinnvoll bewerten. Möchten Sie die Aufgabe trotzdem speichern?",
      completeBeforeAddingParts:
        "Bitte füllen Sie zuerst Name, Modellierungssprache, Beschreibung, Frage und Bewertungsschema aus. Die Aufgabe wird automatisch gespeichert, sobald Sie ein Modell hinzufügen.",
      completeBeforeSaving: "Für die Aufgabe fehlt noch:",
      answersSaveFailed: "Die Antwortoptionen konnten nicht gespeichert werden. Bitte versuchen Sie es erneut.",
      noCorrectAnswerMarked:
        "Keine der Antwortoptionen ist als richtig markiert. Möchten Sie die Aufgabe trotzdem speichern?",
      noInputModelTitle: "Kein gegebenes Modell",
      noAssessmentTitle: "Für diese Einreichung liegt keine abgeschlossene Bewertung vor",
      noAssessmentText:
        "Die letzte Bewertung ist nicht fertig geworden, deshalb gibt es hier noch keine Ergebnisse. Sie können die Bewertung in der Einreichungsliste erneut anstoßen oder die Einreichung in der manuellen Revision selbst bewerten.",
      noAssessmentOnButton: "Keine abgeschlossene Bewertung: Die letzte ist nicht fertig geworden.",
      noInputModelDialogText:
        "Für diese Aufgabe ist noch kein gegebenes Modell hinterlegt. Studierende sehen die Frage dann ohne Modell.",
      saveWithoutModel: "Ohne Modell speichern",
      noCorrectAnswerTitle: "Keine richtige Antwortoption",
      noCorrectAnswerDialogText:
        "Keine der Antwortoptionen ist als richtig markiert. Studierende können die Frage dann nicht richtig beantworten.",
      exerciseCreatedOnSave: "Die Aufgabe wird erst mit dem Speichern angelegt.",
      exerciseCreatedForModel: "Die Aufgabe ist bereits angelegt, weil ein Modell hinzugefügt wurde.",
      exerciseCreatedForModelNote:
        "Die Aufgabe ist bereits angelegt, weil ein Modell nur zusammen mit einer Aufgabe gespeichert werden kann. Wenn Sie das Formular ohne Speichern verlassen, bleibt sie in diesem unvollständigen Zustand in der Aufgabenreihe stehen.",
      saveWithoutCorrectAnswer: "Trotzdem speichern",
      addModelNow: "Modell hinzufügen",
      backToForm: "Zurück zum Formular",
      noInputModelAdded:
        "Für diese Aufgabe ist noch kein gegebenes Modell hinterlegt, Studierende sehen die Frage dann ohne Modell. Die Aufgabe ist bereits angelegt; Abbrechen bringt Sie nur zurück ins Formular. Fortfahren?",
      newModel: "Musterlösung erstellen",
      createModelButton: "Erstellen",
      model: "Modell",
      models: "Modelle",
      modelId: "Modell ID",
      chooseFile: "Datei auswählen",
      answer: "Antwortoptionen",
      wronganswers: "Falsche Antwortoptionen",
      correctanswers: "Korrekte Antwortoptionen",
      schemas: "Schemata",
      schema: "Bewertungsschema",
      visibility: "Sichtbarkeit",
      private: "privat",
      internal: "intern",
      public: "öffentlich",
      question: "Frage/Aufgabenstellung",
      signUp: "Registrieren",
      logOut: "Abmelden",
      existing_model: "Bestehendes Modell",
      assessment: "Bewertung",
      startAssessment: "Bewertung starten",
      showAssessment: "Ergebnisse ansehen",
      selectSubmission: "Einreichung auswählen",
      refresh: "aktualisieren",
      selectModellinglang: "Modellierungssprache auswählen",
      selectSchema: "Bewertungsschema auswählen",
      selectSampleSolution: "Musterlösung auswählen",
      selectVisibility: "Sichtbarkeit auswählen",
      addAnswer: "Antwortoption hinzufügen",
      answers: "Antwortoptionen",
      correct: "Richtig",
      pn: "Petri Netz",
      uml_cd: "UML Klassendiagramm",
      uml_sd: "UML Zustandsdiagramm",
      uml_seq: "UML Sequenzdiagramm",
      ModelsEmpty: "Keine Models ausgewählt",
      startDate: "Startdatum",
      endDate: "Enddatum",
      endDateBeforeStartDate: "Das Enddatum muss nach dem Startdatum liegen.",
      endDateInPast: "Das Enddatum liegt in der Vergangenheit. Die Aufgabenreihe wäre für Studierende sofort abgelaufen. Trotzdem erstellen?",
      createExercise: "Aufgabe erstellen",
      lateExerciseHint:
        "Nachträglich hinzugefügte Aufgaben stehen Studierenden, die diese Aufgabenreihe bereits bearbeitet haben, nicht mehr zur Verfügung. Das ist beabsichtigt: Aufgabenreihen bleiben so konsistent, sobald sie in Benutzung sind.",
      addModel: "Modell hinzufügen",
      deleteModel: "Modell löschen",
      editModel: "Modell bearbeiten",
      createFeedback: "Feedback erstellen",
      feedbackAnchor: "Verankerung im Modell",
      feedbackAnchorHint: "Klicken Sie ein Element im Modell an, um diesen Eintrag daran zu verankern.",
      feedbackAnchorHintDialog:
        "Kein Element ausgewählt. Schließen Sie diesen Dialog, klicken Sie ein Element im Modell an und legen Sie die Rückmeldung dann erneut an.",
      gradingBreakdown: "Woher die automatische Bewertung kommt",
      gradingBreakdownResult: "Ergebnis",
      gradingBreakdownWeight: "Gewicht",
      gradingBreakdownPoints: "Punkte",
      gradingBreakdownHintWeights: "Die Gewichte dieser Dienste ergeben nicht 100 %, sondern",
      gradingBreakdownHint:
        "Jeder Dienst liefert ein relatives Ergebnis. Seine Punkte sind dieses Ergebnis mal seinem Gewicht mal der Maximalpunktzahl.",
      gradingBreakdownHintAbsolute:
        "Mindestens ein Dienst liefert absolute Punkte, deshalb stehen die Ergebnisse hier unverrechnet.",
      numberAssessed: "davon bewertet",
      averageShare: "Durchschnitt",
      feedbackAnchorUnnamed: "Gewähltes Element (ohne Namen)",
      feedbackAnchorClear: "Verankerung lösen",
      elementTypeActivity: "Aktivität",
      elementTypeGateway: "Gateway",
      elementTypeSwimlane: "Swimlane",
      elementTypeLink: "Kante",
      elementTypeEvent: "Ereignis",
      elementTypeEventStart: "Startereignis",
      elementTypeEventIntermediate: "Zwischenereignis",
      elementTypeEventEnd: "Endereignis",
      showInModel: "Im Modell zeigen",
      numberAtElement: "Diese Nummer steht am Modellelement",
      numberWithoutElement: "Nicht verankert, diese Nummer erscheint nicht im Modell",
      noFeedbacks: "Kein Feedback vorhanden",
      quickAccessCode: "Zugriffscode",
      options: "Optionen",
      noExercises: "Es wurden noch keine Aufgaben erstellt!",
      saveAssignment: "Aufgabenreihe speichern",
      saveExercise: "Aufgabe speichern",
      noSubmissions: "Es sind noch keine Einreichungen vorhanden!",
      noAssessment: "Es ist noch keine Bewertung verfügbar!",
      noAssignment: "Es wurden noch keine Aufgabenreihen erstellt!",
      submissions: "Einreichungen",
      cancel: "Abbrechen",
      allSubmissionsForExercise: "Hier sind alle Einreichungen für diesen Studenten aufgelistet: ",
      allSubmissionsForStudent: "Hier sind alle Einreichungen für den ausgewählten Studenten aufgelistet.",
      allExercisesInAssignment: "Hier sind alle in der Aufgabenreihe enthaltenen Aufgaben aufgelistet. ",
      allAssignments:
        "Hier können Aufgabenreihen erstellt und bearbeitet werden. Eine Aufgabenreihe bündelt mehrere einzelne Aufgaben zu einem Thema (wie ein Übungsblatt) unter einem gemeinsamen Zeitraum und Zugriffscode. Studierende bearbeiten und reichen sie gemeinsam ein. Außerdem kann auf 'Bewertung' geklickt werden, um alle enthaltenen Aufgaben der jeweiligen Aufgabenreihe mit den dazugehörigen Einreichungen ansehen zu können.",
      comment: "Kommentar",
      totalScore: "Gesamtpunktzahl",
      maxTotalScore: "Maximale Gesamtpunktzahl",
      content: "Inhalt",
      category: "Kategorie",
      noModel: "Es wurde noch keine Musterlösung erstellt!",
      autoAssessmentAss: "Automatisierte Bewertung bei Einreichung",
      autoAssessmentEx: "Automatisierte Bewertung bei der Bearbeitung",
      autoAssessmentExDesc:
        "Ist diese Option aktiviert, werden Lösungen zu dieser Aufgabe automatisiert bewertet (d.h. Feedback wird generiert) - jedes Mal wenn ein/e Student/in seine/ihre Lösung speichert. Bei diesem sogenannten multiple-try-Feedback können Studierende ihre Lösung im Anschluss immer wieder überarbeiten und sich sukzessive einer guten Lösung nähern. Ist die Option deaktiviert, wird die Lösung erst bei der Einreichung bewertet.",
      autoAssessmentAssDesc:
        "Ist diese Option aktiviert, werden alle eingereichten Lösungen dieser Aufgabenreihe automatisch bewertet und das Feedback wird sofort veröffentlicht. Empfehlung: nicht aktivieren, wenn Sie die Ergebnisse vorher prüfen möchten. Sie stoßen die Bewertung dann unter 'Bewertung' manuell an und korrigieren sie vor der Veröffentlichung.",
      noAnswers: "Es wurden noch keine Antwortoptionen erstellt!",
      noSolution: "Es wurde noch keine Lösung erstellt!",
      exerciseModelCreation: "Aufgabentyp »Modell Erstellen«",
      exerciseModelUnderstanding: "Aufgabentyp »Modell Verstehen«",
      true: "Richtig",
      false: "Falsch",
      integratedFeedback: "Integriertes Feedback",
      ShowModel: "Modell anzeigen",
      preview: "Vorschau",
      MaxScore: "Maximale Gesamtpunktzahl",
      maxScoreInvalidInput: "Hier sind nur Zahlen erlaubt.",
      relativeScoreRange: "Bitte einen Wert zwischen 0 und 1 eingeben (zum Beispiel 0,4 für 40 %).",
      absoluteScoreRange: "Bitte einen Wert zwischen 0 und {{max}} Punkten eingeben.",
      totalScoreNoMax: "Bitte zuerst eine maximale Gesamtpunktzahl festlegen, damit die vergebenen Punkte gespeichert werden können.",
      ofMaxPoints: "von {{max}} Punkten",
      SwitchRoleStudent: "Zur Studierendenansicht",
      answerCorrectColumn: "Richtig?",
      answerIsCorrect: "Richtige Antwort",
      answerIsWrong: "Falsche Antwort",
      markAsCorrect: "Diese Option als richtige Antwort markieren",
      solution: "Lösung",
      proceed: "Ja, fortfahren",
      deleteConfirmationAssignment: "Möchten Sie die folgende Aufgabenreihe wirklich löschen?",
      deleteConfirmationAssignmentIrreversible:
        "Dieser Schritt lässt sich nicht rückgängig machen. Alle zur Aufgabenreihe gehörenden Aufgaben, Einreichungen und Bewertungen werden ebenfalls gelöscht.",
      confirmationRequest: "Sicherheitsabfrage",
      deleteConfirmationExercise: "Möchten Sie die folgende Aufgabe wirklich löschen?",
      deleteConfirmationExerciseIrreversible:
        "Dieser Schritt lässt sich nicht rückgängig machen. Alle zur Aufgabe gehörenden Einreichungen und Bewertungen werden ebenfalls gelöscht.",
      numberOfSubmissions: "Anzahl der Einreichungen",
      numberOfPublished: "Anzahl der veröffentlichten Einreichungen",
      toolTipMC:
        "Bei 'Modell erstellen'-Aufgaben muss zu einem gegebenen Szenario ein passendes Modell erstellt werden. ",
      toolTipMU:
        "Bei 'Modell verstehen'-Aufgaben müssen passende Aussagen zu einem gegebenen Modell ausgewählt werden. ",
      students: "Studenten",
      studentSubmissionsForAssignment:
        "Hier sind alle Studenten aufgelistet, die bereits Aufgaben der Aufgabenreihe eingereicht haben.",
      exerciseType: "Aufgabentyp",
      actions: "Aktionen",
      treeViewEditSchema: "Schema bearbeiten",
      treeViewAddSchema: "Unterschema hinzufügen",
      treeViewAddGradingService: "Bewertungsdienst hinzufügen",
      treeViewEditGradingServiceParameter: "Parameter bearbeiten",
      schemaTreeTooltipWeight100: "Die Gewichtung der Unterschemata summiert sich auf 100%.",
      schemaTreeTooltipWeightNot100: "Die Gewichtung der Unterschemata summiert sich nicht auf 100%.",
      schemaTreeTooltipNoChildren: "Dieses Schema hat keine Unterelemente.",
      newKeyValueDefaultKey: "Name",
      newKeyValueDefaultValue: "Wert",
      newKeyValueDefaultDescription: "Beschreibung",
      "key-value-pairs": "Schlüssel-Wert-Paare",
      addKeyValueItem: "Neues Paar hinzufügen",
      textFiles: "Textdateien",
      newTextFileDefaultName: "neuetextdatei",
      newTextFileDefaultContent: "Inhalt",
      addTextFile: "Textdatei hinzufügen",
      addchildgradingservice: "Bewertungsdienst hinzufügen",
      gradingservice: "Bewertungsdienst",
      selectGradingService: "Bewertungsdienst auswählen",
      searchGradingService: "Bewertungsdienst suchen …",
      noGradingServiceMatch: "Kein Bewertungsdienst passt zur Suche.",
      modelingLanguage: "Modellierungssprache",
      interactionLog: "Interaktionslog",
      scenarioGSTooltip: "Wenn aktiviert, erhält dieser Bewertungsdienst den Szenario-Text der Aufgabe als Eingabe.",
      modelingLanguageGSTooltip: "Wenn aktiviert, erhält dieser Bewertungsdienst die Modellierungssprache der Aufgabe als Eingabe.",
      interactionLogGSTooltip: "Wenn aktiviert, erhält dieser Bewertungsdienst das Interaktionsprotokoll der Einreichung (im Editor aufgezeichnete Bearbeitungsschritte) als Eingabe.",
      weightTooltip:
        "Die Gewichtung des Schemas im Verhältnis zu seinen Geschwistern, in Prozent. Muss einen Wert zwischen 0 und 100 haben.",
      weightTooltipGradingService:
        "Die Gewichtung dieses Bewertungsdienstes im Verhältnis zu seinen Geschwistern, in Prozent. Muss einen Wert zwischen 0 und 100 haben.",
      treeViewNoDescription: "Keine Beschreibung verfügbar.",
      noSchema: "Keine Schemata verfügbar!",
      alreadyCreatingGradingServiceEdge: "Der Bewertungsdienst wird bereits erstellt.",
      fillAllFields: "Bitte stellen Sie sicher, dass alle Felder ausgefüllt sind",
      weightBetween0And100: "Bitte stellen Sie sicher, dass die Gewichtung zwischen 0 und 100 liegt.",
      alreadyCreatingSchema: "Das Schema wird bereits erstellt.",
      addChildSchema: "Unterschema hinzufügen",
      createRootSchema: "Neues Wurzelschema erstellen",
      rootSchemaTooltip:
        "Ein Wurzelschema ist die oberste Ebene eines Bewertungsschemas. Darunter kombinieren Sie Unterschemata und Bewertungsdienste, jeweils mit einer Gewichtung, um festzulegen, wie eine Aufgabe automatisch bewertet wird.",
      childSchemaTooltip:
        "Ein Unterschema bündelt weitere Bewertungsdienste oder Unterschemata unter einem übergeordneten Schema. Die Gewichtung legt fest, wie stark diese Gruppe zum Ergebnis des übergeordneten Schemas beiträgt.",
      gradingServiceRoleTooltip:
        "Ein Bewertungsdienst ist die Komponente, die einen Aspekt einer Einreichung prüft (zum Beispiel Syntax oder Semantik). Sie hängen ihn mit einer Gewichtung unter ein Schema, die seinen Anteil am Ergebnis bestimmt.",
      keyValueEmptyError: "Name und Wert dürfen nicht leer sein",
      updateInProgress: "Die Bewertungsdienstparameter werden bereits aktualisiert.",
      errorCreatingSchema: "Beim Erstellen des Schemas ist ein Fehler aufgetreten.",
      treeViewDeleteConfirmationSchemaAndChildren:
        "Möchten Sie das folgende Schema und alle Unterelemente (Schemata und Bewertungsdienste) wirklich löschen?",
      irreversibleStep: "Dieser Schritt lässt sich nicht rückgängig machen.",
      deleteConfirmationGradingService: "Möchten Sie den folgenden Bewertungsdienst wirklich aus dem Schema entfernen?",
      deleteConfirmationGradingServiceIrreversible: "Dieser Schritt lässt sich nicht rückgängig machen.",
      errorOccurred: "Ein Fehler ist aufgetreten.",
      parameterOfGradingservice: "Parameter des Bewertungsdienstes {gs} (#{id})",
      key: "Schlüssel",
      value: "Wert",
      filename: "Dateiname",
      downloadTextFile: "Textdatei herunterladen",
      onlyChangeOnUpdatePress: "Änderungen werden erst nach Klicken auf 'Aktualisieren' übernommen.",
      Schema: "Schema",
      SchemaRoot: "Wurzelschema",
      GradingService: "Bewertungsdienst",
      treeViewEditGradingServiceWeight: "Gewichtung bearbeiten",
      schemaispublic: "Schema öffentlich teilen (nur Leserechte)",
      PrivateSchema: "Dieses Schema gehört einem anderen Benutzer und ist nicht öffentlich.",
      schematreeviewreadonly: "Sie haben nicht die Berechtigung, dieses Element zu bearbeiten.",
      navschematreeview: "Schemata",
    },
  },
};

i18n
  .use(LngDetector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    detection: ["en-US", "de"],

    keySeparator: false, // we do not use keys in form messages.welcome

    saveMissing: true,

    missingKeyHandler: function (lng, ns, key) {
      console.error("Missing key: ", key);
      return key;
    },

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
